import React from 'react'
import SimpleBanner from '../../components/common/SimpleBanner'
import ProductCard from '../../components/User/Products/ProductCard'

const Products = () => {
  return (
    <div>
        <SimpleBanner title='Our Products'  />
        <ProductCard/>
    </div>
  )
}

export default Products